import { ReactNode } from 'react';
import Iconify from 'src/components/iconify';
import { _mock } from './_mock';

// ----------------------------------------------------------------------

export const _carouselsMembers = [...Array(6)].map((_, index) => ({
  id: _mock.id(index),
  name: _mock.fullName(index),
  role: _mock.role(index),
  avatarUrl: _mock.image.portrait(index),
}));

// ----------------------------------------------------------------------

export const _faqs = [...Array(10)].map((_, index) => ({
  id: _mock.id(index),
  value: `panel${index + 1}`,
  heading: _mock.faqsQuestions(index),
  detail: _mock.faqsAnswers(index),
}));

// ----------------------------------------------------------------------

export const _addressBooks = [...Array(24)].map((_, index) => ({
  id: _mock.id(index),
  primary: index === 0,
  name: _mock.fullName(index),
  email: _mock.email(index + 1),
  fullAddress: _mock.fullAddress(index),
  phoneNumber: _mock.phoneNumber(index),
  company: _mock.companyName(index + 1),
  addressType: index === 0 ? 'Home' : 'Office',
}));

// ----------------------------------------------------------------------

export const _contacts = [...Array(20)].map((_, index) => {
  const status =
    (index % 2 && 'online') || (index % 3 && 'offline') || (index % 4 && 'alway') || 'busy';

  return {
    id: _mock.id(index),
    status,
    role: _mock.role(index),
    email: _mock.email(index),
    name: _mock.fullName(index),
    phoneNumber: _mock.phoneNumber(index),
    lastActivity: _mock.time(index),
    avatarUrl: _mock.image.avatar(index),
    address: _mock.fullAddress(index),
  };
});

// ----------------------------------------------------------------------

export const _notifications = [...Array(9)].map((_, index) => ({
  id: _mock.id(index),
  avatarUrl: [
    _mock.image.avatar(1),
    _mock.image.avatar(2),
    _mock.image.avatar(3),
    _mock.image.avatar(4),
    _mock.image.avatar(5),
    null,
    null,
    null,
    null,
    null,
  ][index],
  type: ['friend', 'project', 'file', 'tags', 'payment', 'order', 'chat', 'mail', 'delivery'][
    index
  ],
  category: [
    'Communication',
    'Project UI',
    'File Manager',
    'File Manager',
    'File Manager',
    'Order',
    'Order',
    'Communication',
    'Communication',
  ][index],
  isUnRead: _mock.boolean(index),
  createdAt: _mock.time(index),
  title:
    (index === 0 && `<p><strong>Deja Brady</strong> sent you a friend request</p>`) ||
    (index === 1 &&
      `<p><strong>Jayvon Hull</strong> mentioned you in <strong><a href='#'>Minimal UI</a></strong></p>`) ||
    (index === 2 &&
      `<p><strong>Lainey Davidson</strong> added file to <strong><a href='#'>File Manager</a></strong></p>`) ||
    (index === 3 &&
      `<p><strong>Angelique Morse</strong> added new tags to <strong><a href='#'>File Manager<a/></strong></p>`) ||
    (index === 4 &&
      `<p><strong>Giana Brandt</strong> request a payment of <strong>$200</strong></p>`) ||
    (index === 5 && `<p>Your order is placed waiting for shipping</p>`) ||
    (index === 6 && `<p>Delivery processing your order is being shipped</p>`) ||
    (index === 7 && `<p>You have new message 5 unread messages</p>`) ||
    (index === 8 && `<p>You have new mail`) ||
    '',
}));

// ----------------------------------------------------------------------

export const TRUST_FEATURES = [
  {
    icon: 'solar:shield-check-bold',
    title: 'GDPR Compliant',
    description: 'We are fully compliant with GDPR regulations to protect your data privacy and rights. Our data processing practices ensure transparency and user consent.',
    status: 'confirmed',
    logo: '/assets/images/trust/gdpr.png'
  },
  {
    icon: 'solar:shield-check-bold',
    title: 'ISO 27001 Certified',
    description: 'We have achieved ISO 27001:2022 certification, demonstrating our commitment to the highest standards of information security management. View Certificate: <a href="https://www.iafcertsearch.org/certification/19jFw6F5kgbrFY3EWo6mwxNH" target="_blank" rel="noopener noreferrer">583AGIS080104</a>',
    status: 'confirmed',
    logo: '/assets/images/trust/iso.webp'
  },
  {
    icon: 'solar:shield-check-outline',
    title: 'TLS 1.3, AES-256 Data Encryption',
    description: 'All data is encrypted using AES-256 Advanced Encryption Standard with TLS protocols. This industry-leading encryption ensures your information remains protected.',
    status: 'confirmed',
  },
  {
    icon: 'solar:cloud-check-bold',
    title: 'Google Cloud Hosting',
    description: 'Our infrastructure is powered by Google Cloud Platform, providing enterprise-grade security, reliability, and global availability across Google Cloud advanced data centers.',
    status: 'confirmed',
    logo: '/assets/images/trust/google-cloud-hosting.webp'
  },
];

// ----------------------------------------------------------------------

export const _mapContact = [
  {
    latlng: [33, 65],
    address: _mock.fullAddress(1),
    phoneNumber: _mock.phoneNumber(1),
  },
  {
    latlng: [-12.5, 18.5],
    address: _mock.fullAddress(2),
    phoneNumber: _mock.phoneNumber(2),
  },
];

// ----------------------------------------------------------------------

export const arrow = (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.2147 30.6123C6.71243 22.9891 10.1906 14.9695 17.1738 11.0284C24.2834 7.01748 33.9187 7.08209 41.1519 10.6817C42.6578 11.4331 41.4507 13.5427 39.9511 12.945C33.399 10.3368 25.7611 10.0919 19.3278 13.1729C16.5269 14.4946 14.2131 16.6643 12.7143 19.3746C10.7314 22.9202 11.202 26.5193 11.6878 30.3396C11.8055 31.2586 10.5388 31.3074 10.2147 30.6123Z"
      fill="#919EAB"
      fillOpacity="0.24"
    />
    <path
      d="M11.8126 39.0341C9.56032 35.9944 6.83856 32.7706 6.01828 28.9795C5.98242 28.8458 5.99937 28.7036 6.0656 28.5821C6.13183 28.4607 6.24226 28.3694 6.374 28.3271C6.50573 28.2849 6.64867 28.295 6.77316 28.3553C6.89765 28.4157 6.99414 28.5216 7.04263 28.6511C8.43444 31.8092 10.4092 34.463 12.553 37.1099C13.8625 35.3195 14.915 33.2716 16.4773 31.7142C16.6164 31.5741 16.8007 31.4879 16.9974 31.471C17.1941 31.4541 17.3905 31.5075 17.5515 31.6218C17.7125 31.736 17.8277 31.9037 17.8767 32.095C17.9257 32.2863 17.9052 32.4887 17.8189 32.6663C16.5996 35.0298 15.0564 37.2116 13.2339 39.1484C13.1391 39.2464 13.0238 39.3222 12.8963 39.3703C12.7688 39.4185 12.6321 39.4378 12.4963 39.4268C12.3604 39.4159 12.2286 39.375 12.1104 39.3071C11.9922 39.2392 11.8905 39.1459 11.8126 39.0341Z"
      fill="#919EAB"
      fillOpacity="0.24"
    />
  </svg>
);

// ----------------------------------------------------------------------
type SocialItem = {
  value: string;
  name: string;
  icon: JSX.Element;
  color: string;
  path: string;
};

export const _socials: SocialItem[] = [
  {
    value: 'youtube',
    name: 'Youtube',
    icon: (
      <Iconify icon="logos:youtube-icon" width={25} />
    ),
    color: '#00AAEC',
    path: 'https://www.youtube.com/@SimpleTranslate1',
  },
  {
    value: 'linkedIn',
    name: 'LinkedIn',
    icon: (
      <Iconify icon="skill-icons:linkedin" width={25} />
    ),
    color: '#00AAEC',
    path: 'https://www.linkedin.com/company/106943809',
  },
  {
    value: 'appExchange',
    name: 'AppExchange',
    icon: (
      <Iconify icon="logos:salesforce" width={25} />
    ),
    color: '#00AAEC',
    path: 'https://appexchange.salesforce.com/appxListingDetail?listingId=a8fdfe72-852d-4709-b8ca-7cdfd4457517',
  },
];

// ----------------------------------------------------------------------

export const simpleTranslatePricingPlans = [
  {
    name: 'Free Edition',
    price: 0,
    period: 'per org / month',
    popular: false,
    features: [
      'Up to 50,000 TOKEN (APROX 10,000 Words)',
      'Translation Engines: Google, DeepL, AWS, OpenAI',
      'Unlimited Users',
      'No Support available.',
    ],
    buttonText: 'Start for Free',
    color: 'inherit'
  },
  {
    name: 'Professional License',
    price: 500,
    period: 'per org / month',
    yearlyPrice: 5500,
    popular: true,
    features: [
      'Up to 1,000,000 TOKEN (APROX 200,000 Words)',
      'Unlimited Users Licenses',
      'Standard Support',
    ],
    buttonText: 'Start Professional',
    color: 'primary'
  },
  {
    name: 'Enterprise License',
    price: null,
    period: 'Custom pricing',
    popular: false,
    features: [
      'Everything in Professional, plus:',
      'Custom Defined Tokens',
      'Enterprise Support with SLA',
    ],
    buttonText: 'Contact Sales',
    color: 'inherit'
  }
];

export const simpleTranslateYearlyPlans = [
  {
    name: 'Free Edition',
    price: 0,
    period: 'per org / year',
    popular: false,
    features: [
      'Up to 50,000 TOKEN (APROX 10,000 Words)',
      'Translation Engines: Google, DeepL, AWS, OpenAI',
      'Unlimited Users',
      'No Support available.',
    ],
    buttonText: 'Start for Free',
    color: 'inherit'
  },
  {
    name: 'Professional License (Annual)',
    price: 5500,
    period: 'per org / year',
    yearlyPrice: 5500,
    popular: true,
    features: [
      'Up to 1,000,000 TOKEN (APROX 200,000 Words)',
      'Unlimited Users Licenses',
      'Standard Support',
      'Save €500 per year (1 month free)'
    ],
    buttonText: 'Start Professional',
    color: 'primary'
  },
  {
    name: 'Enterprise License',
    price: null,
    period: 'Custom pricing',
    popular: false,
    features: [
      'Everything in Professional, plus:',
      'Custom Defined Tokens',
      'Enterprise Support with SLA',
      'Flexible annual pricing options'
    ],
    buttonText: 'Contact Sales',
    color: 'inherit'
  }
];

// ----------------------------------------------------------------------

export const componentsPricingPlans = [
  {
    subscription: 'Free Edition',
    price: 0,
    caption: 'Perfect for getting started',
    labelAction: 'Get Started',
    isFree: true,
    lists: [
      'Up to 200 AI requests per month',
      'Bring your own LLM',
      'SimpleT defined LLMs: OpenAI 4.1mini',
    ],
  },
  {
    subscription: 'Monthly License (BYO-LLM)',
    price: 10,
    caption: 'Bring your own LLM',
    labelAction: 'Choose Plan',
    isPopular: true,
    lists: [
      'Up to 1,000 AI requests per month/license',
      'Bring your own LLM',
      'Priority support',
    ],
  },
  {
    subscription: 'Monthly License (LLM Included)',
    price: 20,
    caption: 'SimpleT defined LLMs',
    labelAction: 'Choose Plan',
    lists: [
      'Up to 1,000 AI requests per month/license',
      'SimpleT provides and manages LLM',
      'Predefined LLM Models by SimpleT',
      'Priority support',
    ],
  },
  {
    subscription: 'Enterprise License',
    price: '',
    caption: 'For organizations with 100+ users',
    labelAction: 'Contact Sales',
    lists: [
      'Custom Defined AI Requests Token',
      'Custom SLA agreements',
      'Enterprise  Priority Support ',
    ],
  },
];

export const componentsYearlyPlans = [
  {
    subscription: 'Free Edition',
    price: 0,
    caption: 'Perfect for getting started',
    labelAction: 'Get Started',
    isFree: true,
    lists: [
      'Up to 200 AI requests per month',
      'Bring your own LLM',
      'SimpleT defined LLMs: OpenAI 4.1mini',
    ],
  },
  {
    subscription: 'Yearly License (BYO-LLM)',
    price: 110,
    caption: 'Cost-efficient for annual commitments',
    labelAction: 'Choose Plan',
    isPopular: true,
    isYearly: true,
    lists: [
      'Up to 1,000 AI requests per month/license',
      'Bring your own LLM',
      'Priority support',
      'Save €10 per year',
    ],
  },
  {
    subscription: 'Yearly License (LLM Included)',
    price: 220,
    caption: 'SimpleT defined LLMs',
    labelAction: 'Choose Plan',
    isYearly: true,
    lists: [
      'Up to 1,000 AI requests per month/license',
      'SimpleT provides and manages LLM',
      'Predefined LLM Models by SimpleT',
      'Priority support',
      'Save €20 per year',
    ],
  },
  {
    subscription: 'Enterprise License',
    price: '',
    caption: 'For organizations with 100+ users',
    labelAction: 'Contact Sales',
    isYearly: true,
    lists: [
      'Custom Defined AI Requests Token',
      'Custom SLA agreements',
      'Enterprise  Priority Support ',
    ],
  },
];

// ----------------------------------------------------------------------

export const _testimonials = [
  {
    name: _mock.fullName(1),
    postedDate: _mock.time(1),
    ratingNumber: _mock.number.rating(1),
    avatarUrl: _mock.image.avatar(1),
    content: `Excellent Work! Thanks a lot!`,
  },
  {
    name: _mock.fullName(2),
    postedDate: _mock.time(2),
    ratingNumber: _mock.number.rating(2),
    avatarUrl: _mock.image.avatar(2),
    content: `It's a very good dashboard and we are really liking the product . We've done some things, like migrate to TS and implementing a react useContext api, to fit our job methodology but the product is one of the best in terms of design and application architecture. The team did a really good job.`,
  },
  {
    name: _mock.fullName(3),
    postedDate: _mock.time(3),
    ratingNumber: _mock.number.rating(3),
    avatarUrl: _mock.image.avatar(3),
    content: `Customer support is realy fast and helpful the desgin of this theme is looks amazing also the code is very clean and readble realy good job !`,
  },
  {
    name: _mock.fullName(4),
    postedDate: _mock.time(4),
    ratingNumber: _mock.number.rating(4),
    avatarUrl: _mock.image.avatar(4),
    content: `Amazing, really good code quality and gives you a lot of examples for implementations.`,
  },
  {
    name: _mock.fullName(5),
    postedDate: _mock.time(5),
    ratingNumber: _mock.number.rating(5),
    avatarUrl: _mock.image.avatar(5),
    content: `Got a few questions after purchasing the product. The owner responded very fast and very helpfull. Overall the code is excellent and works very good. 5/5 stars!`,
  },
  {
    name: _mock.fullName(6),
    postedDate: _mock.time(6),
    ratingNumber: _mock.number.rating(6),
    avatarUrl: _mock.image.avatar(6),
    content: `CEO of Codealy.io here. We’ve built a developer assessment platform that makes sense - tasks are based on git repositories and run in virtual machines. We automate the pain points - storing candidates code, running it and sharing test results with the whole team, remotely. Bought this template as we need to provide an awesome dashboard for our early customers. I am super happy with purchase. The code is just as good as the design. Thanks!`,
  },
];
